import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import View from "../View.mjs";

import OrdemDeServicoItemService from "./OrdemDeServicoItemService";

export default {

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async pegaViewRecebimentoDeNotaFiscalRecebidaPega(){

        let ordensDePagamento;

        try{

            //==================================================================//
            //==================== Pega Ordens de Pagamento ====================//
            //==================================================================//

            ordensDePagamento = await ERP.getManyWithView(View.RECEBIMENTO_DE_NOTA_FISCAL_RECEBIDA_PEGA_PEDIDO_DE_COMPRA_DA_NOTA_FISCAL_RECEBIDA,[
                {
                    name: "owner",
                    dataType: "String",
                    // value: usuarioStore.usuario.id
                },
            ]);

        }catch(e){

            console.log(e);
            return ordensDePagamento;

        }

        return ordensDePagamento;

    },


    // Método emergencial da tela de Recebimento de Nota Fiscal
    // O correto seria o aoSalvarNotaFiscalRecebida chamar um método nessa service de "salvarNotaFiscalRecebida"
    // Afim de encurtar a lógica porem ainda expondo a bugs foi cortado em duas partes.
    // Futuramente refatorar o método pai em um método completo aqui.
    async realizarRecebimentoDeNotaFiscalRecebida(ordemDeServicoItemValores = {}){

        let ordemDeServico;

        try{

                //==================================================================//
                //=================== PEGA ORDEM DE SERVICO ITEM ===================//
                //==================================================================//

                let ordemDeServicoItemID = ordemDeServicoItemValores?.id || "";

                let ordemDeServicoItem = await ERP.getOneById(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoItemID);
                if(ordemDeServicoItem.status != 200){
                    throw ordemDeServicoItem;
                }

                //==================================================================//
                //========= CALCULAR RECEBIMENTO DA ORDEM DE SERVICO ITEM ==========//
                //==================================================================//

                let quantidadeParaReceber = ordemDeServicoItem?.data?.quantidadeParaReceber ?? 0;
                let quantidadeRecebida = ordemDeServicoItem?.data?.quantidadeRecebida ?? 0;
                let quantidadeRecebendo = ordemDeServicoItemValores?.quantidadeRecebendo ?? 0;

                quantidadeParaReceber = quantidadeParaReceber - quantidadeRecebendo;
                quantidadeRecebida = quantidadeRecebida + quantidadeRecebendo;

                quantidadeParaReceber = Math.max(0,quantidadeParaReceber);
                quantidadeRecebida = Math.max(0,quantidadeRecebida);

                //==================================================================//
                //=========== DETERMINA O STATUS DA ORDEM DE SERVICO ITEM ==========//
                //==================================================================//

                let statusAtual = "GP";

                if(quantidadeParaReceber == 0){
                    statusAtual = 'RE';
                }else{
                    statusAtual = 'RP';
                }

                //==================================================================//
                //=================== ALTERA ORDEM DE SERVICO ITEM =================//
                //==================================================================//

                ordemDeServicoItemValores = {
                    id: ordemDeServicoItemID,
                    quantidadeParaReceber: quantidadeParaReceber || 0,
                    quantidadeRecebida: quantidadeRecebida || 0,
                    status: statusAtual || "GP",
                }

                ordemDeServico = await OrdemDeServicoItemService.alterarItem(ordemDeServicoItemValores);
                if(ordemDeServico.status != 200){
                    throw ordemDeServico;
                }

        }catch(e){

            console.log(e);
            return ordemDeServico;

        }

        return ordemDeServico;

    },

}